import React from 'react'
import { NonIdealState } from '@blueprintjs/core'

export const ErrorMessage = ({ message }) => {
    const hasMessage = message && message.trim && message.trim() && message.trim().length > 0
    const messageDescription = hasMessage ?
        <>
            <p>{message}</p>
            <p>Please contact your administrator for further assistance.</p>
        </> :
        <>
            <p>Please contact your administrator.</p>
        </>

    return <NonIdealState
        icon='error'
        title={hasMessage ? 'The following error occurred:' : 'An error has occurred.'}
        className='errorText'
        description={messageDescription}
    />
}

export const ErrorFallback = ({ error, resetErrorBoundary}) => {
    return <ErrorMessage message={error.message} />
}